import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '../services/CredentialsService.js'

const OffDayRepository = RepositoryFactory.get('offDay')

class OffDayService {
  static async getOffDays (params) {
    try {
      return await OffDayRepository.getOffDays(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
  static async createOffDays (data) {
    try {
      return await OffDayRepository.createOffDays(CredentialsService.getCurrentTenantId(), data)
    } catch (error) {
      console.log(error)
    }
  }
  static async updateOffDays (offDayId, data) {
    try {
      return await OffDayRepository.updateOffDays(CredentialsService.getCurrentTenantId(), offDayId, data)
    } catch (error) {
      console.log(error)
    }
  }
  static async deleteOffDays (offDayId) {
    try {
      return await OffDayRepository.deleteOffDays(CredentialsService.getCurrentTenantId(), offDayId)
    } catch (error) {
      console.log(error)
    }
  }
}

export default OffDayService
